module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group row",
    class: {
      'has-danger': _vm.error
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.companies,
      "searchable": true,
      "close-on-select": true,
      "show-labels": false,
      "value": _vm.company,
      "loading": _vm.loading,
      "placeholder": "Компания не выбрана",
      "track-by": "id",
      "label": "name",
      "autocomplete": "off"
    },
    on: {
      "open": _vm.loadCompanies,
      "input": _vm.changeCompany
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("Компания не найдена.")])]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "small help-block text-danger"
  }, [_vm._v("Компания обязательно должена быть указана")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("Компания "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d3da9a2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-6d3da9a2"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcSelectCompany.vue
// module id = 1048
// module chunks = 1